import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance, { adminurl, weburl } from "../../axiosInstance";
import HeaderPage from "../components/HeaderPage";
import { Helmet } from "react-helmet";
 

const SignupUserType = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
    const [Nurse, setAllNurse] = useState([]);
    const [Skill, setAllSkill] = useState([]);
    const [Attribute, setAllAttribute] = useState([]);


  const [inputs, setInputs] = useState({
    type: "1",
    empType: "2",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    Gender: "1",
    DOB: "",
    address: "",
    Nurse : [],
    skill : [],
    attribute : [],
      Shift: [], // should be an array, not a string
      DutyShift: [], // should be an array, not a string
    // profile: null, // Changed to null to match file type
    // DLfile: null,
    // AadhaarFront: null,
    // AadhaarBack: null,
    // PoliceVerification: null,
    // PassPort: null,
    // Electricity: null,
    // WaterBill: null,
  });

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0];
    } else {
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
    }
    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }


      if (name === "nurse") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.nurse) ? inputs.nurse : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          nurse: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
     if (name === "skill") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.skill) ? inputs.skill : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          skill: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
      if (name === "attribute") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.attribute) ? inputs.attribute : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          attribute: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }

  if (name === "Shift" || name === "DutyShift") {
    const selected = Array.isArray(inputs[name]) ? [...inputs[name]] : [];

    if (!selected.includes(value)) {
      selected.push(value);
      setInputs((prev) => ({
        ...prev,
        [name]: selected,
      }));
    }

      return null;
  }
    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [showPassword, setShowPassword] = useState(false);

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async () => {
    setSubmitLoading(false);
    console.log(inputs);

    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "password", message: "Please enter password" },
      { name: "confirm_password", message: "Please enter confirm password" },
      { name: "state", message: "Please enter State" },
      { name: "city", message: "Please enter State" },
      { name: "pincode", message: "Please enter pincode" },
      { name: "address", message: "Please enter address" },
      // Fields below are conditionally required based on inputs.type
      ...(inputs.type !== "3"
        ? [
            { name: "Gender", message: "Please enter Gender" },
            { name: "DOB", message: "Please enter DOB" },
          ]
        : []),
  ...(inputs.empType === '4' && inputs.type === '1'
        ? [ 
           { name: "location", message: "Please enter location" }, 
             { name: "Salary", message: "Please enter Salary" },
             { name: "Experience", message: "Please enter Experience" },
            { name: "Shift", message: "Please choose Shift" },
              { name: "DutyShift", message: "Please choose Duty Shift" },
               { name: "Education", message: "Please entere Education" },
             { name: "MaritalStatus", message: "Please choose Marital Status" },
              { name: "nurse", message: "Please choose Duty Nurse Department" }, 
             { name: "MaritalStatus", message: "Please choose Nurse skill" }, 
             { name: "MaritalStatus", message: "Please choose Nurse Attribute" }, 
 
          ]
        : []),
         
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(true);
        return;
      }
    }

    if (inputs.password !== inputs.confirm_password) {
      toast.error("Password does not match");
      setSubmitLoading(true);
      return;
    }

    
    // Email Validation (basic regex)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(inputs.email)) {
      toast.error("Please enter a valid email address");
      setSubmitLoading(true);
      return;
    }

    // DOB Validation (age 18+)
    let dob = new Date(inputs.DOB);
    let today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    let m = today.getMonth() - dob.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    if (age < 18) {
      toast.error("You must be at least 18 years old");
      setSubmitLoading(true);
      return;
    }

    console.log("mydata", inputs);

    try {
     
      const { data } = await axiosInstance.post(
        `/signup-user-type`,
        inputs,
           {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { success } = data;
      if (success) {
        toast.success("Account Created Successfully  ");
        // navigate('/all-user/2');
        setTimeout(() => {
          window.location.href = adminurl;
        }, 1000);
      }
    } catch (error) {
      console.error("Error On Signup:", error);
      toast.error(error.response.data.message);
      setSubmitLoading(true);

    } finally {
      setSubmitLoading(true);
    }

    setSubmitLoading(true);
  };

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };



    const fetchNurseData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-nurse-department");
      console.log("response.data.Department,", response.data);
      setAllNurse(response.data.Department || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  
    const fetchNurseSkillData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-nurse-skill-department");
      console.log("response.data.Department,", response.data);
      setAllSkill(response.data.Department || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

   const fetchNurseAttributeData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-nurse-attributes-department");
      console.log("response.data.Attribute,", response.data);
      setAllAttribute(response.data.Department || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNurseData();
    fetchNurseSkillData();
    fetchNurseAttributeData();
    fetchData();
  }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

    const removeNurse = (data) => {
    setInputs((prev) => ({
      ...prev,
      nurse: prev.nurse.filter((c) => c !== data),
    }));
  };


  const removeShift = (valueToRemove) => {
  setInputs(prev => ({
    ...prev,
    Shift: prev.Shift.filter(val => val !== valueToRemove)
  }));
};

  const removeDutyShift = (valueToRemove) => {
  setInputs(prev => ({
    ...prev,
    DutyShift: prev.DutyShift.filter(val => val !== valueToRemove)
  }));
};
 

  
  
    const removeSkill = (data) => {
    setInputs((prev) => ({
      ...prev,
      skill: prev.skill.filter((c) => c !== data),
    }));
  };


  
    const removeAttribute = (data) => {
    setInputs((prev) => ({
      ...prev,
      attribute: prev.attribute.filter((c) => c !== data),
    }));
  };


  return (
    <>
    


      <HeaderPage title={'Signup Driver' } />
    
          <Helmet>
            <title> Checkout | {window.location.hostname}</title>
          </Helmet>
    
    
    
    <main className="page-content space-top dz-gradient-shape bg-light">
     
 

 
        <div className="container pt-0 px-0">
          <div
            className="dashboard-content bg-white px-4 py-3 "
            style={{ maxWidth: "100vw" }}
          >
            <div className="card  border-0">
              <form className="m-b20 row">
              
               
                  <label className="mb-2 h4 border-bottom mb-4 pb-2">Become a Driver</label>

                <div className="mb-4">
                  <label className="form-label text-dark" htmlFor="name">
                    Full Name <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="text"
                      id="username"
                      className="form-control"
                      name="username"
                      value={inputs.username}
                      onChange={handleChange}
                    />
                  </div>
                </div>

              
                <div className="mb-4 col-6">
                  <label className="form-label text-dark" htmlFor="name">
                    Phone <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="number"
                      id="phone"
                      className="form-control"
                      name="phone"
                      value={inputs.phone}
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          // Check input length before updating
                          handleChange(e); // Call handleChange if length is within limit
                        }
                      }}
                      onInput={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 10) {
                          setInputs({ ...inputs, phone: inputValue });
                        }
                      }}
                      // onChange={() => {
                      //   handleChange();
                      // }}
                    />
                  </div>
                </div>

                  {(inputs.empType === '4' && inputs.type === '1') && 
                   <div className="mb-4 col-6">
                  <label className="form-label text-dark" htmlFor="AltPhone">
                    Alternative Phone  
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="number"
                      id="AltPhone"
                      className="form-control"
                      name="AltPhone"
                      value={inputs.AltPhone}
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          // Check input length before updating
                          handleChange(e); // Call handleChange if length is within limit
                        }
                      }}
                      onInput={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 10) {
                          setInputs({ ...inputs, AltPhone: inputValue });
                        }
                      }}
                     
                    />
                  </div>
                </div> }

                <div className="mb-4 col-6">
                  <label className="form-label text-dark" htmlFor="email">
                    Email <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      name="email"
                      value={inputs.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="password">
                    Password <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-control dz-password"
                      name="password"
                      value={inputs.password}
                      onChange={handleChange} // Add onChange handler to manage input changes
                      // onKeyPress={(e) => {
                      //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                      //     submitLoginPass();
                      //   }
                      // }}
                    />
                    <span className="input-group-text text-primary p-1">
                      {/* Toggle password visibility button */}
                      <i
                        className={
                          showPassword
                            ? "ri-eye-off-fill cursor"
                            : "ri-eye-fill cursor"
                        }
                        onClick={togglePasswordVisibility}
                      />
                    </span>
                  </div>
                </div>
                <div className="mb-4 col-md-6">
                  <label className="form-label text-dark" htmlFor="password">
                    Confirm Password{" "}
                    <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group   input-sm">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      className="form-control dz-password"
                      name="confirm_password"
                      value={inputs.confirm_password}
                      onChange={handleChange} // Add onChange handler to manage input changes
                      // onKeyPress={(e) => {
                      //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                      //     submitLoginPass();
                      //   }
                      // }}
                    />
                    <span className="input-group-text text-primary p-1">
                      {/* Toggle password visibility button */}
                      <i
                        className={
                          showPassword
                            ? "ri-eye-off-fill cursor"
                            : "ri-eye-fill cursor"
                        }
                        onClick={togglePasswordVisibility}
                      />
                    </span>
                  </div>
                </div>

                {inputs.type !== "3" && (
                  <div className="mb-4 col-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={inputs.gender}
                        name="gender"
                        onChange={handleChange}
                      >
                        <option selected disabled>
                          {" "}
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>
                )}

                {inputs.type !== "3" && (
                  <div className="mb-4 col-6  ">
                    <label className="form-label text-dark" htmlFor="email">
                      DOB <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                   
                      <input
                        type="date"
                        id="DOB"
                        className="form-control custom-date"
                        name="DOB"
                        value={inputs.DOB}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}

                <div className="mb-4 col-6  ">
                  <label className="form-label text-dark" htmlFor="email">
                    State <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="state"
                      name="state"
                      value={inputs.state}
                      onChange={handleChange}
                    >
                      <option selected disabled>
                        {" "}
                        {loading ? "Loading..." : "Select State"}
                      </option>
                      {data && data.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}{" "}
                      ;
                    </select>
                  </div>
                </div>

                <div className="mb-4 col-6 ">
                  <label className="form-label text-dark" htmlFor="city">
                    City <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="city"
                      name="city"
                      value={inputs.city}
                      onChange={handleChange}
                    >
                      <option selected value={""}>
                        {" "}
                        {loading ? "Loading..." : "Select City"}
                      </option>
                      {filteredCities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}{" "}
                      ;
                    </select>
                  </div>
                </div>

                <div className="mb-4 col-6  ">
                  <label className="form-label text-dark" htmlFor="email">
                    Pincode of current address <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                      type="number"
                      id="pincode"
                      className="form-control custom-date"
                      name="pincode"
                      value={inputs.pincode}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                  {(inputs.empType === '4' && inputs.type === '1') && 
  <div className="mb-4 col-12  ">
                  <label className="form-label text-dark" htmlFor="location">
                    Location <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                      type="text"
                      id="location"
                      className="form-control custom-date"
                      name="location"
                      value={inputs.location}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                  }

                <div className="mb-4  ">
                  <label className="form-label text-dark" htmlFor="email">
                   {(inputs.empType === '4' && inputs.type === '1') ?
                   <>
                    Permanent Address <span className="text-danger"> ( Required )</span>
                   </>
                     :
                     <>
                    Address <span className="text-danger"> ( Required )</span>
                   </> }
                  </label>
                  <div className="input-group    input-sm">
                    <textarea
                      className="form-control"
                      id="address"
                      name="address"
                      onChange={handleChange}
                      rows="2"
                    >
                      {inputs.address}
                    </textarea>
                  </div>
                </div>

                  {(inputs.empType === '4' && inputs.type === '1') && 
                     <div className="mb-4 ">
                  <label className="form-label text-dark" htmlFor="AltAddress">
                   Current Address  
                  </label>
                  <div className="input-group    input-sm">
                    <textarea
                      className="form-control"
                      id="AltAddress"
                      name="AltAddress"
                      onChange={handleChange}
                      rows="2"
                    >
                      {inputs.AltAddress}
                    </textarea>
                  </div>
                </div>
                  }


                     {(inputs.empType === '4' && inputs.type === '1') && 
                     <> 
                     <div className="mb-4 col-md-3">
                  <label className="form-label text-dark" htmlFor="Salary">
                   Salary <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                      type="number"
                      className="form-control"
                      id="Salary"
                      name="Salary"
                      onChange={handleChange}
                      value={inputs.Salary}
                    /> 
                  </div>
                </div>

                 <div className="mb-4 col-md-3 ">
                  <label className="form-label text-dark" htmlFor="Salary">
                   Experience <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="number"
                      className="form-control"
                      id="Experience"
                      name="Experience"
                      onChange={handleChange}
                      value={inputs.Experience}
                    /> 
                  </div>
                </div>

<div className="mb-4 col-md-3">
  <label className="form-label text-dark" htmlFor="Shift">
    Shift  
    <span className="text-danger"> (Required)</span>
  </label>

  <div className="input-group input-sm">
    <select
      className="form-control"
      id="Shift"
      name="Shift"
      onChange={handleChange}
      value=""
      required
    >
      <option value="">Select Shift</option>
      <option value="Day">Day</option>
      <option value="Night">Night</option>
    </select>
  </div>

  <div className="mb-4">
    {Array.isArray(inputs.Shift) && inputs.Shift.length > 0 ? (
      inputs.Shift.map((shiftValue, index) => (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeShift(shiftValue)}
          title="Click to remove"
        >
          {shiftValue} ×
        </span>
      ))
    ) : (
      <span className="text-muted">No shift selected.</span>
    )}
  </div>
</div>

<div className="mb-4 col-md-3">
  <label className="form-label text-dark" htmlFor="DutyShift">
    Duty Shift  
    <span className="text-danger"> ( Required )</span>
  </label>
  
  <div className="input-group input-sm">
    <select
      className="form-control"
      id="DutyShift"
      name="DutyShift"
      onChange={handleChange}
      value=""
      required
    >
      <option value="">Select Duty Shift</option>
      <option value="8 Hours">8 Hours</option>
      <option value="10 Hours">10 Hours</option>
      <option value="12 Hours">12 Hours</option>
      <option value="24 Hours">24 Hours</option>
    </select>
  </div>

  <div className="mb-4">
    {Array.isArray(inputs.DutyShift) && inputs.DutyShift.length > 0 ? (
      inputs.DutyShift.map((shiftValue, index) => (
        <span
          key={index}
          className="badge bg-success me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeDutyShift(shiftValue)}
          title="Click to remove"
        >
          {shiftValue} ×
        </span>
      ))
    ) : (
      <span className="text-muted">No duty shift selected.</span>
    )}
  </div>
</div>


          <div className="mb-4 col-md-6 ">
                  <label className="form-label text-dark" htmlFor="Education">
                   Education <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="text"
                      className="form-control"
                      id="Education"
                      name="Education"
                      onChange={handleChange}
                      value={inputs.Education}
                    /> 
                  </div>
                </div>


  <div className="mb-4 col-md-6 ">
                    <label className="form-label text-dark" htmlFor="MaritalStatus">
                      Marital status <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={inputs.MaritalStatus}
                        name="MaritalStatus"
                        onChange={handleChange}
                      >
                        <option selected disabled>
                          {" "}
                          Select status
                        </option>
                        <option value="Married">Married</option>
                        <option value="Unmarried">Unmarried</option>
                       </select>
                    </div>
                  </div>


    
      {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Staff Category <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="nurse"
            name="nurse"
         onChange={handleChange}
         selected={inputs.nurse}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Staff Category 
            </option>
            {Nurse.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.nurse) && inputs.nurse.length > 0 ? (
   inputs.nurse.map((departmentId, index) => {
      const department = Nurse.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeNurse(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Staff Category selected.</span>
  )}
</div>


 {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse skill <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="skill"
            name="skill"
         onChange={handleChange}
         selected={inputs.skill}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Skill Department
            </option>
            {Skill.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.skill) && inputs.skill.length > 0 ? (
     inputs.skill.map((departmentId, index) => {
      const department = Skill.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeSkill(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Skill department selected.</span>
  )}
</div>




 {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse Attribute <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="attribute"
            name="attribute"
         onChange={handleChange}
         selected={inputs.attribute}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Attribute Department
            </option>
            {Attribute.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.attribute) && inputs.attribute.length > 0 ? (
    inputs.attribute.map((departmentId, index) => {
      const department = Attribute.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeAttribute(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Attribute department selected.</span>
  )}
</div>



                </>
                  }



   <div className="mb-4 col-6 col-md-6">
                          <label className="form-label text-dark" htmlFor="profileImage">
                            Profile Image
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
  {inputs.profile && typeof inputs.profile === "string" ? (
    <img
      src={inputs.profile !== "" ? weburl + inputs.profile : "/img/profile-default.png"}
      id="ProfileImage"
      alt="Profile Image"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: "",
        objectFit: "cover",
        border: "1px solid grey",
      }}
    />
  ) : (
    <img
      src={inputs.profile && typeof inputs.profile === "string" && inputs.profile !== "" 
        ? weburl + inputs.profile 
        : "/img/profile-default.png"}
      id="ProfileImage"
      alt="Profile Image"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: "",
        objectFit: "cover",
        border: "1px solid grey",
      }}
    />
  )}
  <input
    type="file"
    id="profileImage"
    className="form-control"
    name="profileImage"
    accept=".jpg, .jpeg, .png, .webp"
    onChange={(event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const imgElement = document.getElementById("ProfileImage");
          if (imgElement) {
            imgElement.src = e.target.result; // Set the image URL directly on the img element
          }
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        setInputs((prevData) => ({ ...prevData, profile: file })); // Update profile in state
      }
    }}
  />
</div>

                        </div>

   {/* Duplicate for Doc2 */}
                        <div className="mb-4 col-6 col-md-6">
                          <label className="form-label text-dark" htmlFor="Doc2">
                            Aadhaar card (Front)
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
                            {inputs.Doc2 && typeof inputs.Doc2 === "string" && inputs.Doc2.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                id="LicensingImage2"
                                alt="Document 2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                id="LicensingImage2"
                                alt="Document 2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc2"
                              className="form-control"
                              name="Doc2"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage2");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc2: file }));
                                }
                              }}
                            />
                          </div>
                        </div>

                        {/* Duplicate for Doc3 */}
                        <div className="mb-4 col-6 col-md-6">
                          <label className="form-label text-dark" htmlFor="Doc3">
                            Aadhaar card (Back)
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
                            {inputs.Doc3 && typeof inputs.Doc3 === "string" && inputs.Doc3.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                id="LicensingImage3"
                                alt="Document 3"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                id="LicensingImage3"
                                alt="Document 3"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc3"
                              className="form-control"
                              name="Doc3"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage3");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc3: file }));
                                }
                              }}
                            />
                          </div>
                        </div>
                        


                <div className="col-md-12 me-auto">
                  {SubmitLoading ? (
                    <button
                      className="btn btn-thin btn-md btn-primary rounded-xl"
                      type="button"
                      onClick={handleSubmit}
                    >
                      {inputs.type === "1" && "Signup as a Employee"}{" "}
                      {inputs.type === "2" && "Signup as a User"}
                     </button>
                  ) : (
                    <button
                      disabled
                      className="btn btn-thin btn-lg w-100 btn-dark rounded-xl"
                      type="button"
                    >
                      <span className="ms-1">Loading...</span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
 
</main>
     </>
  );
};

export default SignupUserType;
